import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-vehicles',
  templateUrl: './vehicles.component.html',
  styleUrls: ['./vehicles.component.scss']
})
export class VehiclesComponent implements OnInit {

  vehicles : any;

  view : any;
  sort = "name";

  formGroup  = new FormGroup ({
    search: new FormControl('',[]),
    enabled: new FormControl('enabled',[]),
  });

  pagination = { page: 1, pageSize: 1, itemCount: 1, totalPages: 1, pageArray: [1], totalCount: 1 };

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService) { }

  ngOnInit(): void {

    this.pagination.page = 1;

    if(this.okService.settings.order_now){
      this.formGroup  = new FormGroup ({
        search: new FormControl('',[]),
        enabled: new FormControl('licensed',[]),
      });
    }

    this.getVehicles();

  }

  getVehicles(){

    let filter = {
      sort: this.sort,
      search: this.formGroup.value.search,
      enabled: this.formGroup.value.enabled,
      page: this.pagination.page,
      expand: "drivers"
    }

    //console.log('filter', filter);

    this.okService.get("vehicles",filter)
    .subscribe((data) => {

      this.vehicles = data.body;
      this.pagination = this.okService.setPagination(data.headers) ?? this.pagination;

      //console.log("vehicles",data);

    });

  }

  updateFilter(){
    if (this.formGroup.valid) {
        //console.log('update filter', this.formGroup.value);
        this.getVehicles();
    }
  }

  // Get the vehicle token and login as that vehicle
  dashboardLogin(vehicle:any){

    let url = this.okService.dashboardUrl+"/vehicle/update/"+vehicle.id+"?ul="+this.okService.session.token+"&cid="+vehicle.company_id;

    window.open(url);

  }

  toggleEnabled(vehicle:any){

    vehicle.enabled = + !vehicle.enabled;

    this.okService.put('vehicles/'+vehicle.id,{'enabled':vehicle.enabled})
    .subscribe((data) => {
      //console.log("toggle enabled",data)


    }
    );
  }


  refreshLicenses(){
    
    this.okService.get("vehicles/licenses",{})
    .subscribe((data) => {

      //console.log(data);
    
      this.getVehicles();

    });
  }

}
